import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import routeMeta from "./routeMeta.json";

const ORIGIN = "https://quarec.com";
const DEFAULT = routeMeta["/"];
const ARTICLE_ROUTES = new Set([
  "/Firstday",
  "/RecruitmentMarketing",
  "/Changed",
  "/Internal-Momentum",
  "/Proven",
  "/Automation",
  "/Generative-AI",
  "/QuestionOne",
  "/QuationTwo",
]);

export default function RouteSeo() {
  const { pathname } = useLocation();
  const path = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
  const matched = routeMeta[path];
  const data = matched || DEFAULT;
  const canonical = `${ORIGIN}${path}`;
  const indexable = Boolean(matched);
  const isArticle = ARTICLE_ROUTES.has(path);

  return (
    <Helmet>
      <html lang="en" />
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={indexable ? "index,follow" : "noindex,follow"} />
      <meta property="og:type" content={isArticle ? "article" : "website"} />
      <meta property="og:site_name" content="Quarec Resources" />
      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary" />
    </Helmet>
  );
}
